var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChromeIncognito(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2v6u4hi1ta"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1486 0v950H0V0h1486z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gbxiyrckab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm4.667 17.29a3.623 3.623 0 0 0-3.526 2.804 2.852 2.852 0 0 0-2.282-.01 3.631 3.631 0 0 0-3.526-2.794 3.63 3.63 0 0 0-3.63 3.622 3.63 3.63 0 0 0 3.63 3.621 3.607 3.607 0 0 0 3.599-3.332c.31-.217 1.13-.62 2.136.021.166 1.852 1.7 3.311 3.599 3.311a3.63 3.63 0 0 0 3.63-3.621 3.63 3.63 0 0 0-3.63-3.622zm-9.334 1.035a2.59 2.59 0 0 1 2.593 2.587 2.59 2.59 0 0 1-2.593 2.586 2.59 2.59 0 0 1-2.592-2.586 2.59 2.59 0 0 1 2.592-2.587zm9.334 0a2.59 2.59 0 0 1 2.592 2.587 2.59 2.59 0 0 1-2.592 2.586 2.59 2.59 0 0 1-2.593-2.586 2.59 2.59 0 0 1 2.593-2.587zm4.666-3.125H6.667v1.067h18.666V15.2zm-7.176-7.947L16 7.977l-2.167-.724-.052-.016a1.04 1.04 0 0 0-1.245.637l-2.364 6.26h11.656l-2.375-6.26-.02-.05a1.04 1.04 0 0 0-1.276-.571z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2v6u4hi1ta)",
    transform: "translate(-405 -285)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gbxiyrckab)",
    transform: "translate(405 285)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5A6870",
    d: "M0 0h32v32H0V0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeIncognito);
export default __webpack_public_path__ + "static/media/chrome-incognito.b5ba04b6915b6f04479263b8f8895b62.svg";
export { ForwardRef as ReactComponent };